'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

var _bUserPicMProviderYandexTeam = (require('./../../user-pic/user-pic.react.js'), (require('./../../user-pic/_provider/user-pic_provider_yandex-team.react.js').default || require('./../../user-pic/_provider/user-pic_provider_yandex-team.react.js')).applyDecls());

var _bUserPicMProviderYandexTeam2 = _interopRequireDefault(_bUserPicMProviderYandexTeam);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'user-account',
    elem: 'pic',
    render: function render() {
        var block = this.block,
            elem = this.elem,
            _props = this.props,
            pic = _props.pic,
            avatarId = _props.avatarId,
            avatarHost = _props.avatarHost,
            provider = _props.provider;


        if (pic) {
            return _react2.default.createElement(_bUserPicMProviderYandexTeam2.default, {
                avatarId: avatarId,
                provider: provider,
                host: avatarHost,
                mix: { block: block, elem: elem, mods: this.mods(this.props) }
            });
        }

        return this.__base.apply(this, arguments);
    }
}, {
    propTypes: {
        avatarId: _propTypes2.default.string,
        avatarHost: _propTypes2.default.string
    }
});